var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.02779C6.93849 3.07771 5.53671 2.5 4 2.5C3.29873 2.5 2.62556 2.62031 2 2.84141V12.3414C2.62556 12.1203 3.29873 12 4 12C5.53671 12 6.93849 12.5777 8 13.5278M8 4.02779C9.06151 3.07771 10.4633 2.5 12 2.5C12.7013 2.5 13.3744 2.62031 14 2.84141V12.3414C13.3744 12.1203 12.7013 12 12 12C10.4633 12 9.06151 12.5777 8 13.5278M8 4.02779V13.5278",
    stroke: "#4C7D9F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.53c41c9368b1eea62870e4c8de5e6683.svg";
export { ForwardRef as ReactComponent };